export const urlToPathname = (url: string, { preserveQueryParams = false } = {}): string => {
  const a = document.createElement('a');
  a.href = url;
  return (
    (a.pathname.startsWith('/') ? '' : '/') +
    a.pathname +
    (preserveQueryParams ? a.search : '') +
    (a.hash ? a.hash : '')
  );
};
